<script setup lang="ts">
import type { LoyaltyProgram } from '@/types/types'
import LegalSection from './settings/LegalSection.vue'

defineProps<{
  section: string
  loyaltyProgram: LoyaltyProgram
}>()

const emit = defineEmits<{
  (e: 'update:loyaltyProgram', value: LoyaltyProgram): void
}>()
</script>

<template>
  <LegalSection
    v-if="section === 'legal'"
    :loyalty-program="loyaltyProgram"
    @update:loyalty-program="emit('update:loyaltyProgram', $event)"
  />
</template>
